
// NEWS
export const SET_ACTIVE_NEWS_FEED_ALL_NEWS = 'SET_ACTIVE_NEWS_FEED_ALL_NEWS';
export const SET_ACTIVE_NEWS_FEED_FAV_NEWS = 'SET_ACTIVE_NEWS_FEED_FAV_NEWS';

// LAWS
export const SET_ACTIVE_LAWS_FEED_ALL_PUB = 'SET_ACTIVE_LAWS_FEED_ALL_PUB';
export const SET_ACTIVE_LAWS_FEED_MY_FAV = 'SET_ACTIVE_LAWS_FEED_MY_FAV';
export const SET_ACTIVE_LAWS_FEED_MY_ACTIONS = 'SET_ACTIVE_LAWS_FEED_MY_ACTIONS';
export const SET_ACTIVE_LAWS_FEED_WAITING_ANSWER = 'SET_ACTIVE_LAWS_WAITING_ANSWER';



// WEBPACK FOOTER //
// ./src/redux_related/activeFeed/actions.js